<script setup lang="ts">
import './tag.css';
import '@sg-core/src/View/Components/Atoms/Box/box.css';

defineProps({
  spacing: {
    type: [Number, String],
    default: 1,
  },

  use: {
    type: String,
    default: 'div',
  },
});
</script>

<template>
  <component
    :is="use"
    :class="['phxsg-box phxsg-box--solid phxsg-tag title-caption', { [`phxsg-box--spacing-${spacing}`]: spacing }]"
    v-bind="$attrs"
  >
    <slot />
  </component>
</template>
